import { 
    GET_CONFIG_FORM35,
    GET_INGRESO_GRILLA

} from '../types';

export default function ingresoRecobroReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM35:
            return { ...state, cfg_form35:action.payload }
        case GET_INGRESO_GRILLA:
            return { ...state, datosRecobro:action.payload }
       
       
        default:
            return state
    }
}